import { defineMessages, useIntl } from 'react-intl-next';

import Button from '@atlaskit/button/new';

import { useAppUpdatesContext } from '@app/app/src/AppContext';

const messages = defineMessages({
  label: {
    id: 'appUpdates.filters.recentlyPublished.label-nonfinal',
    description: 'Label for the new this week filter chip',
    defaultMessage: 'New this week',
  },
});

const getEffectiveFrom = (): string => {
  const date = new Date();
  date.setDate(date.getDate() - 7);

  return date.toISOString();
};

export const DateRangeFilter = () => {
  const { formatMessage } = useIntl();
  const { state, dispatch } = useAppUpdatesContext();

  const isActive = state.updates.committedFilters.effectiveFrom !== null;

  const handleToggle = () => {
    dispatch({
      type: 'FILTER_EFFECTIVE_FROM_TOGGLE',
      payload: {
        effectiveFrom: isActive ? null : getEffectiveFrom(),
      },
    });
  };

  return (
    <Button
      appearance="default"
      isSelected={isActive}
      onClick={handleToggle}
      testId="app-updates-recently-published-filter"
      aria-label={formatMessage(messages.label)}
      aria-pressed={isActive}
    >
      {formatMessage(messages.label)}
    </Button>
  );
};
